import FlowProgressBanner from "./flowProgressBanner";
import BotOpsTurnTrace from "./botOpsTurnTrace";

/**
 * Layout compartilhado Chat sandbox / Testes live / replay.
 *
 * @param {"live"|"replay"|"free"} mode
 * @param {number|string|null} conversationId
 * @param {boolean} locked
 * @param {object|null} progress
 * @param {import("react").ReactNode} childrenChat
 * @param {string} token
 * @param {boolean} isActive
 * @param {string|null} ownerFallback
 * @param {object|null} [conversationLive] status CW live (SoR) do poll da sessão
 * @param {function} onToastBad
 * @param {import("react").ReactNode} [childrenSide] painel lateral em replay
 * @param {{ events?: object[], untilTs?: string|null }|null} [traceReplay]
 */
const BotOpsLiveShell = ({
    mode,
    conversationId,
    locked: _locked,
    progress,
    childrenChat,
    token,
    isActive,
    ownerFallback = null,
    conversationLive = null,
    onToastBad,
    childrenSide = null,
    traceReplay = null,
}) => {
    const showProgressBanner = mode === "live" && progress;
    const showLiveTrace = Boolean(conversationId) && mode !== "replay";
    const showReplayTrace = mode === "replay" && (traceReplay || conversationId);
    const sidePanel = showLiveTrace ? (
        <BotOpsTurnTrace
            token={token}
            conversationId={conversationId}
            isActive={isActive}
            onToastBad={onToastBad}
            ownerFallback={ownerFallback}
            conversationLive={conversationLive}
        />
    ) : showReplayTrace ? (
        <BotOpsTurnTrace
            token={token}
            conversationId={conversationId}
            isActive={false}
            mode="replay"
            events={traceReplay?.events ?? []}
            untilTs={traceReplay?.untilTs ?? null}
            onToastBad={onToastBad}
            ownerFallback={ownerFallback}
        />
    ) : (
        childrenSide
    );
    const hasSide = Boolean(sidePanel);

    return (
        <div
            className={
                hasSide
                    ? "grid items-start gap-3 lg:grid-cols-[minmax(0,1fr)_22rem]"
                    : "grid items-start gap-3"
            }
            data-testid="bot-ops-live-shell"
            data-mode={mode}
            data-locked={_locked ? "true" : "false"}
            data-has-side={hasSide ? "true" : "false"}
        >
            <div className="min-w-0 space-y-3">
                {showProgressBanner ? (
                    <FlowProgressBanner progress={progress} />
                ) : null}
                {childrenChat}
            </div>

            {hasSide ? sidePanel : null}
        </div>
    );
};

export default BotOpsLiveShell;
